
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
@Component({
  components: {},
  filters:{}
})
export default class Test extends Vue {
  
  /// props
  @Prop({ default: false }) private isLoading!: boolean
  @Prop({ default: "" }) private label!: string
  
  /// data
  private data: Object = {}
  private loadingDot: string = ""
  private loadingTimer: any = undefined
  
  /// provide data
  @Provide() provideData: Object = {}
  
  // computed
  private get infos(): Array<any> {
      return Array<any>()
  }
  
  /// lifecycle
  created() {
    
  }
  
  mounted() {
    
  }
  
  /// methods
  public methodOne(params: any): void {
    
  }
  /// watch methods
  @Watch('newList', { immediate: true, deep: true })
  onArrayChanged(newVal: any, oldVal: any) {
    
  }

  @Watch('isLoading', { immediate: true, deep: true })
  onLoadingChanged(newVal: any, oldVal: any) {
    if(newVal){
        // this.loadingTimer
        this.initilizeTimer()
    }else{
        clearInterval(this.loadingTimer)
        this.loadingDot = ""
    }
  }

  private initilizeTimer() {

    clearInterval(this.loadingTimer)
    this.loadingDot = ""
    this.loadingTimer = setInterval(()=>{
        
        if(this.loadingDot === '...'){
            this.loadingDot = ''
        }else{
            this.loadingDot += "."
        }

    }, 500)
  }
}
